/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener(
  'click',
  function (event) {
    const button = event.target.closest(
      '[data-quantity-plus], [data-quantity-minus]'
    );

    if (!button) return;

    const counter = button.closest('quantity-counter');
    if (!counter) return;

    const field = counter.querySelector('[data-quantity-field]');
    if (!field) return;

    const step = Number(field.getAttribute('step')) || 1;
    const min = Number(field.getAttribute('min')) || 1;
    const isCartItem = Boolean(counter.closest('[data-cart-item]'));

    let quantity = Number(field.value);

    if (!Number.isFinite(quantity)) {
      quantity = min;
    }

    /*
     * Palo Alto's native quantity counter adds or subtracts 1.
     * Adjust the field by step - 1 first, then allow the theme's
     * original handler to make the final 1-unit adjustment.
     *
     * This preserves the theme's built-in cart update and subtotal refresh.
     */

    if (button.matches('[data-quantity-plus]')) {
      field.value = quantity + (step - 1);
    }

    if (button.matches('[data-quantity-minus]')) {
      if (isCartItem && quantity <= min) {
        // Leave the value alone so Palo Alto changes it to 0
        // and removes the line item through its normal cart process.
        return;
      }

      if (!isCartItem && quantity <= min) {
        // Palo Alto normally changes the minimum to 0.
        // Setting it one above the minimum makes its native -1
        // return the field to the minimum instead.
        field.value = min + 1;
        return;
      }

      field.value = quantity - (step - 1);
    }
  },
  true
);


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
